import BORDERLESS_CANCELED_SVG from 'icons/_icon_status_canceled_borderless.svg';
import BORDERLESS_CREATED_SVG from 'icons/_icon_status_created_borderless.svg';
import BORDERLESS_FAILED_SVG from 'icons/_icon_status_failed_borderless.svg';
import BORDERLESS_MANUAL_SVG from 'icons/_icon_status_manual_borderless.svg';
import BORDERLESS_PENDING_SVG from 'icons/_icon_status_pending_borderless.svg';
import BORDERLESS_RUNNING_SVG from 'icons/_icon_status_running_borderless.svg';
import BORDERLESS_SKIPPED_SVG from 'icons/_icon_status_skipped_borderless.svg';
import BORDERLESS_SUCCESS_SVG from 'icons/_icon_status_success_borderless.svg';
import BORDERLESS_WARNING_SVG from 'icons/_icon_status_warning_borderless.svg';

import CANCELED_SVG from 'icons/_icon_status_canceled.svg';
import CREATED_SVG from 'icons/_icon_status_created.svg';
import FAILED_SVG from 'icons/_icon_status_failed.svg';
import MANUAL_SVG from 'icons/_icon_status_manual.svg';
import PENDING_SVG from 'icons/_icon_status_pending.svg';
import RUNNING_SVG from 'icons/_icon_status_running.svg';
import SKIPPED_SVG from 'icons/_icon_status_skipped.svg';
import SUCCESS_SVG from 'icons/_icon_status_success.svg';
import WARNING_SVG from 'icons/_icon_status_warning.svg';

export const borderlessStatusIconEntityMap = {
  icon_status_canceled: BORDERLESS_CANCELED_SVG,
  icon_status_created: BORDERLESS_CREATED_SVG,
  icon_status_failed: BORDERLESS_FAILED_SVG,
  icon_status_manual: BORDERLESS_MANUAL_SVG,
  icon_status_pending: BORDERLESS_PENDING_SVG,
  icon_status_running: BORDERLESS_RUNNING_SVG,
  icon_status_skipped: BORDERLESS_SKIPPED_SVG,
  icon_status_success: BORDERLESS_SUCCESS_SVG,
  icon_status_warning: BORDERLESS_WARNING_SVG,
};

export const statusIconEntityMap = {
  icon_status_canceled: CANCELED_SVG,
  icon_status_created: CREATED_SVG,
  icon_status_failed: FAILED_SVG,
  icon_status_manual: MANUAL_SVG,
  icon_status_pending: PENDING_SVG,
  icon_status_running: RUNNING_SVG,
  icon_status_skipped: SKIPPED_SVG,
  icon_status_success: SUCCESS_SVG,
  icon_status_warning: WARNING_SVG,
};



// WEBPACK FOOTER //
// ./vue_shared/ci_status_icons.js